import { createAction, props } from '@ngrx/store';
import { Notification } from '../_models/notification';

// Action types
export const loadNotifications = createAction('[Notification] Load Notifications');
export const loadNotificationsSuccess = createAction(
  '[Notification] Load Notifications Success',
  props<{ notifications: Notification[] }>()
);
export const loadNotificationsFailure = createAction(
  '[Notification] Load Notifications Failure',
  props<{ error: any }>()
);

export const addNotification = createAction(
  '[Notification] Add Notification',
  props<{ notification: Notification }>()
);
export const addNotificationSuccess = createAction(
  '[Notification] Add Notification Success',
  props<{ notification: Notification }>()
);
export const addNotificationFailure = createAction(
  '[Notification] Add Notification Failure',
  props<{ error: any }>()
);

export const updateNotification = createAction(
  '[Notification] Update Notification',
  props<{ notification: Notification }>()
);
export const updateNotificationSuccess = createAction(
  '[Notification] Update Notification Success',
  props<{ notification: Notification }>()
);
export const updateNotificationFailure = createAction(
  '[Notification] Update Notification Failure',
  props<{ error: any }>()
);

export const deleteNotification = createAction(
  '[Notification] Delete Notification',
  props<{ id: number }>()
);
export const deleteNotificationSuccess = createAction(
  '[Notification] Delete Notification Success',
  props<{ id: number }>()
);
export const deleteNotificationFailure = createAction(
  '[Notification] Delete Notification Failure',
  props<{ error: any }>()
);
